import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-add-business-external-links",
  templateUrl: "./add-business-external-links.component.html",
  styleUrls: ["./add-business-external-links.component.scss"],
})
export class AddBusinessExternalLinksComponent implements OnInit {
  domainName: any;
  initialDomainName: any; // Add this property to track the original value

  google_business_url: any;
  google_business_review_url: any;
  facebook_url: any;
  facebook_review_url: any;
  instagram_url: any;
  twitter_url: any;
  linkedin_url: any;
  youtube_url: any;
  google_play_store_url: any;
  apple_app_store_url: any;
  privacy_policy_url: any;
  terms_of_services_url: any;
  refund_policy_url: any;
  cookie_policy_url: any;

  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<AddBusinessExternalLinksComponent>,
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_BUSINESS_SOCIAL_LINKS
      ) {
        if (resdata.result) {
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }
  domainData: any;
  ngOnInit(): void {
    this.domainData = this.parentdata.domainMappingData;

    this.google_business_url = this.domainData.google_business_url;
    this.google_business_review_url =
      this.domainData.google_business_review_url;
    this.facebook_url = this.domainData.facebook_url;
    this.facebook_review_url = this.domainData.facebook_review_url;
    this.instagram_url = this.domainData.instagram_url;
    this.twitter_url = this.domainData.twitter_url;
    this.linkedin_url = this.domainData.linkedin_url;
    this.youtube_url = this.domainData.youtube_url;
    this.google_play_store_url = this.domainData.google_play_store_url;
    this.apple_app_store_url = this.domainData.apple_app_store_url;
    this.privacy_policy_url = this.domainData.privacy_policy_url;
    this.terms_of_services_url = this.domainData.terms_of_services_url;
    this.refund_policy_url = this.domainData.refund_policy_url;
    this.cookie_policy_url = this.domainData.cookie_policy_url;
  }

  get isSaveDisabled(): boolean {
    // Disable if the name is empty OR if it hasn't changed from the original
    return (
      !this.domainName ||
      this.domainName.trim() === "" ||
      this.domainName === this.initialDomainName
    );
  }
  onsave() {
    let obj = {
      entity_hash: this.parentdata.entity_hash,
      google_business_url: this.google_business_url,
      google_business_review_url: this.google_business_review_url,
      facebook_url: this.facebook_url,
      facebook_review_url: this.facebook_review_url,
      instagram_url: this.instagram_url,
      twitter_url: this.twitter_url,
      linkedin_url: this.linkedin_url,
      youtube_url: this.youtube_url,
      google_play_store_url: this.google_play_store_url,
      apple_app_store_url: this.apple_app_store_url,
      privacy_policy_url: this.privacy_policy_url,
      terms_of_services_url: this.terms_of_services_url,
      refund_policy_url: this.refund_policy_url,
      cookie_policy_url: this.cookie_policy_url,
    };
    Object.keys(obj).forEach((key) => {
      if (
        (obj as any)[key] === null ||
        (obj as any)[key] === undefined ||
        (obj as any)[key] === "" ||
        (obj as any)[key] === "null"
      ) {
        delete (obj as any)[key];
      }
    });
    this.ls.showLoader = true;
    this.apiservice.setBusinessSocialLinks(obj);
  }
}
